<script lang="ts">
    import {derived, get, Writable, writable} from 'svelte/store'
    import {createEventDispatcher} from 'svelte'
    import translate from '../../../../lib/translate'
    import {ShowType, IProduct} from '../../types/Show'
    import label from './ProductsTab.translation'
    import ProductDetails from './ProductsTab/ProductDetails.svelte'
    import {
        showStore as show,
        currentProductStore as currentProduct,
        productsStore as products,
        nextProductsStore as nextProducts,
        currentProductIdStore
    } from '../../stores'

    // local stores
    
    const tabProducts = derived(
        [show, products, nextProducts],
        ([$show, $products, $nextProducts]) => {
            if( $show.meta?.type === ShowType.MultiProduct || 
                $show.meta?.type === ShowType.MultiCreation
            ) {
                return $products
            } else {
                return [...$products, ...$nextProducts].splice(0,6)
            }
        }
    )
    
    export const selectedProductId = <Writable<string|null>>writable(null)
    const selectedProduct = <IProduct|null>derived(
        [tabProducts, currentProduct, selectedProductId],
        ([$tabProducts, $currentProduct, $selectedProductId]) => {
            let product = null
            if($selectedProductId !== null) {
                product = $tabProducts.filter(product => product.productId === $selectedProductId)[0]
            }
            if(!product && $currentProduct) {
                product = $tabProducts.filter(product => product.productId === $currentProduct.productId)[0]
            }
            if(!product && $tabProducts.length > 0) {
                product = $tabProducts[0] 
            }
            return product
        }
    )
    
    // events

    const dispatch = createEventDispatcher()
    const selectProduct = (productId: string) => {
        dispatch('productSelected', {
            productId: productId
        })
        selectedProductId.set(productId)
    }

    // helpers
    
    const itemClasses = (product: IProduct, selectedProduct: IProduct|null): string => {
        
        let showData = get(show)
        let classes = ['bietagent-item-list-item']
        if(product.productId === selectedProduct?.productId) {
            classes.push('selected')
        }
        if( showData.meta?.type === ShowType.MultiProduct ||
            showData.meta?.type === ShowType.MultiCreation) {
            if(!product.available) {
                classes.push('sold-out')
            }
            classes.push('current-show')
        } else if(get(currentProductIdStore) === product.productId) {
            classes.push('current-show')
        }
        return classes.join(' ')
    }
</script>

<h2 class="auction-product-details-title">
    <span>{translate(label.productsTabTitle)}</span>
</h2>
<ul class="bietagent-item-list auction-product-next-list">
    {#each $tabProducts as product}
        <li class="{itemClasses(product, $selectedProduct)}" 
            on:click="{() => selectProduct(product.productId)}"
        >
            <span>
                <img draggable="false" src="{product.image.size300}" alt="{product.name}">
            </span>
        </li>
    {/each}
</ul>

<ProductDetails product={$selectedProduct} />